export default {
	title: 'Compte ameli',
	logoBtn: {
		label: 'Accueil',
		alt: 'l\'Assurance Maladie'
	}
};
